export function shouldShowFirstCopyCallout({
  featureFlagsLoading,
  enabled,
  copiesUsed,
  freeLimit,
  isPublicationsRoute,
}) {
  return (
    isPublicationsRoute === true &&
    featureFlagsLoading !== true &&
    enabled === true &&
    Number(copiesUsed) === 0 &&
    Number(freeLimit) === 5
  );
}
